import React from 'react';
import PropTypes from 'prop-types';
import CategoryRow from './CategoryRow';
import BannerTile from './BannerTile';

const Categories = props => {
  const {
    categories = [],
    fptiClick,
    fptiImpression,
    toolTileProps,
    viewAllText
  } = props;

  const isLoggedIn = toolTileProps.app?.context?.user?.isLoggedIn;
  const {
    flatPSData: {
      isRecommendedCategoryEligible,
      recommended = [],
      isQuizBannerLayout
    } = {},
    experimentation: { coloredIconsExp: isColoredIconsEligible } = {}
  } = toolTileProps;

  return (
    <div id="appcenter-categories">
      {categories.map(({ content = {}, featured = [] }, index) => (
        <>
          {isLoggedIn &&
          isRecommendedCategoryEligible &&
          recommended[0].isCategoryDisable &&
          recommended[0].isCategoryDisable !== 'TRUE' &&
          isQuizBannerLayout &&
          index === 2 ? (
            <BannerTile
              content={recommended[0]}
              fptiClick={fptiClick}
              fptiImpression={fptiImpression}
            />
          ) : null}
          <CategoryRow
            key={`appcenter-categories-${index}`}
            content={content}
            featured={featured}
            viewAllText={viewAllText}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
            toolTileProps={toolTileProps}
            isColoredIconsEligible={isColoredIconsEligible}
          />
        </>
      ))}
    </div>
  );
};

Categories.propTypes = {
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  categories: PropTypes.array,
  toolTileProps: PropTypes.object,
  viewAllText: PropTypes.string,
  isColoredIconsEligible: PropTypes.bool
};

export default Categories;
